import { motion } from "framer-motion";
import v1 from "./assets/V1.svg";
import v2 from "./assets/V2.svg";
import v3 from "./assets/V3.svg";
import v4 from "./assets/V4.svg";
import v5 from "./assets/V5.svg";
import v6 from "./assets/V6.svg";

const AboutCoreValues = () => {
  const features = [
    {
      id: "innovation",
      title: "Innovation",
      description:
        "We constantly explore new ideas and technologies to deliver smarter, future-ready solutions. We embrace curiosity, creativity, and continuous improvement to shape the future of workforce management.",
      bgColor: "#DFFFEA",
      iconUrl: v1,
    },
    {
      id: "integrity-transparency",
      title: "Integrity & Transparency",
      description:
        "We believe in honest communication, ethical practices, and complete transparency in everything we do. Trust is the foundation of every relationship we build — with customers, partners, and our team.",
      bgColor: "#E9F4FB",
      iconUrl: v2,
    },
    {
      id: "people-relationships",
      title: "People & Relationships",
      description:
        "Technology has meaning only when it enhances human potential. We value people first and focus on building long-term relationships through respect, empathy, and collaboration.",
      bgColor: "#FFF4D8",
      iconUrl: v3,
    },
    {
      id: "teamwork-collaboration",
      title: "Teamwork & Collaboration",
      description:
        "We grow stronger together. Our culture thrives on teamwork, shared goals, and collective success, where every idea is valued and every contribution counts.",
      bgColor: "#FFE9DD",
      iconUrl: v4,
    },
    {
      id: "customer-success",
      title: "Customer Success",
      description:
        "Our customers’ success is our purpose. We commit to delivering solutions that create measurable impact, improve efficiency, and drive excellence across operations.",
      bgColor: "#E9F4FB",
      iconUrl: v5,
    },
    {
      id: "excellence-accountability",
      title: "Excellence & Accountability",
      description:
        "We take ownership of our work and hold ourselves to the highest standards. Through dedication, discipline, and performance excellence, we turn commitments into achievements.",
      bgColor: "#FFECEE",
      iconUrl: v6,
    },
  ];

  return (
    <motion.section
      initial={{ opacity: 0, scale: 0.97 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      viewport={{ once: true }}
      className="w-full font-['Epilogue'] px-4 sm:px-6 lg:px-8 py-16 overflow-hidden"
    >
  
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
        className="text-center text-[38px] font-bold text-gray-900 mb-12"
      >
        Our Core Values
      </motion.h2>

  
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <motion.div
            key={feature.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.45,
              delay: index * 0.1,
              ease: "easeOut",
            }}
            viewport={{ once: true }}
            whileHover={{
              scale: 1.05,
              y: -6,
              boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
              transition: { duration: 0.25 },
            }}
            className="bg-white border border-gray-200 rounded-2xl p-6 flex flex-col"
            style={{ willChange: "transform" }}
          >
            
            <motion.div
              className="flex items-center justify-center w-full h-[120px] rounded-xl mb-6"
              style={{ backgroundColor: feature.bgColor }}
              whileHover={{
                scale: 1.1,
                rotate: 5,
                transition: { duration: 0.25 },
              }}
            >
              <motion.img
                loading="lazy"
                src={feature.iconUrl}
                alt={feature.title}
                className="w-[60px] h-[60px]"
                initial={{ scale: 0.85, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.18,
                }}
                viewport={{ once: true }}
                whileHover={{
                  scale: 1.2,
                  rotate: -5,
                  transition: { duration: 0.25 },
                }}
              />
            </motion.div>

            {/* Title */}
            <h3 className="text-gray-900 font-semibold text-[18px] mb-2">
              {feature.title}
            </h3>

            {/* Description */}
            <p className="text-gray-600 text-[16px] leading-[26px]">
              {feature.description}
            </p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default AboutCoreValues;
